module.exports = __webpack_public_path__ + "gamecode/img/dtmslgtw_favicon.png?552710fe";